import api from '../../api';
import { Branch, Schedule } from '@deliveries-app/models';
import { ScheduleResponse } from '../models/schedule-response.interface';

async function getBranches(): Promise<Branch[]> {
  try {
    const res = await api.get<{
      success: boolean;
      data: Branch[];
    }>('/api/v1/branches');

    if (!res.data.success) {
      throw new Error('Get all branches failed');
    }

    return res.data.data;
  } catch (err) {
    console.log('Get all branches failed', err);
    throw err;
  }
}

async function getBranch(branch_id: number): Promise<Branch> {
  try {
    const res = await api.get<{
      success: boolean;
      data: Branch;
    }>(`/api/v1/branches/${branch_id}`, {
      params: {
        vehicles: true,
      },
    });

    if (!res.data.success) {
      throw new Error('Get branch failed');
    }

    return res.data.data;
  } catch (err) {
    console.log('Get branch failed', err);
    throw err;
  }
}

async function getSchedule(
  branch_id: number,
  day?: string
): Promise<Schedule[]> {
  try {
    const res = await api.get<ScheduleResponse>(
      `/api/v1/branches/${branch_id}/schedules`,
      {
        params: {
          day,
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log('Get schedule failed', err);
    throw err;
  }
}

async function updateSchedule(
  branch_id: number,
  schedule: Schedule
): Promise<Schedule> {
  try {
    const res = await api.post<{
      success: boolean;
      data: Schedule;
    }>(`/api/v1/branches/${branch_id}/schedules`, {
      day: schedule.day,
      number_of_available_drivers: schedule.number_of_available_drivers,
    });

    if (!res.data.success) {
      throw new Error('Update schedule failed');
    }

    return res.data.data;
  } catch (err) {
    console.log('Update schedule failed', err);
    throw err;
  }
}

export const branchService = {
  getBranches,
  getBranch,
  getSchedule,
  updateSchedule,
};
